import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import Image from '../../../../../../atoms/Image/Image';
import { EAGER_LOAD_STRATEGY } from '../../../../../../atoms/Image/Image.constants';
import MarkdownContent from '../../../../../../components/MarkdownContent/MarkdownContent';
import { EVENT_ACTIONS, EVENT_CATEGORIES } from '../../../../../analytics/components/Event';
import { BaseCarouselPropTypes } from '../../../../../foundation/components/Carousel/types/base';
import BasicCarousel from '../../../../../foundation/components/Carousel/variants/BasicCarousel/BasicCarousel';
import { getItemKey } from '../../../../../foundation/services/props';
import WebsiteComponentInteraction from '../../../../../interactions/components/WebsiteComponentInteraction/WebsiteComponentInteraction';
import { CuratedHeroVariantPropTypes, CuratedHeroVariantDefaultProps } from '../../../../types';
import { HERO_CONTENT_COMPONENT_ID, HERO_IMAGE_COMPONENT_ID } from '../../CuratedHero.constants';
import { getCuratedHeroConfiguration, getContentNodeContent, getImageSource, getImageAltText } from '../../CuratedHero.utils';
import './TranquilTouch.less';
var defaultProps = _objectSpread({
  carouselProps: {}
}, CuratedHeroVariantDefaultProps);
export default function TranquilTouch(_ref) {
  var componentConfigurations = _ref.componentConfigurations,
    carouselProps = _ref.carouselProps;
  var imageConfiguration = getCuratedHeroConfiguration(componentConfigurations, HERO_IMAGE_COMPONENT_ID);
  var contentConfiguration = getCuratedHeroConfiguration(componentConfigurations, HERO_CONTENT_COMPONENT_ID);
  if (_isEmpty(contentConfiguration)) {
    return null;
  }
  var _ref2 = imageConfiguration || {},
    _ref2$files = _ref2.files,
    files = _ref2$files === void 0 ? [] : _ref2$files;
  var _ref3 = contentConfiguration || {},
    _ref3$contentNodes = _ref3.contentNodes,
    contentNodes = _ref3$contentNodes === void 0 ? [] : _ref3$contentNodes,
    _ref3$interactions = _ref3.interactions,
    interactions = _ref3$interactions === void 0 ? [] : _ref3$interactions;
  var content = getContentNodeContent(contentNodes);
  return /*#__PURE__*/React.createElement("div", {
    className: "curated-hero tranquil-touch"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-container"
  }, /*#__PURE__*/React.createElement(MarkdownContent, {
    content: content
  }), !_isEmpty(interactions) && /*#__PURE__*/React.createElement("div", {
    className: "ctas-container"
  }, interactions.map(function (interaction) {
    var interactionId = interaction._id;
    return /*#__PURE__*/React.createElement(WebsiteComponentInteraction, {
      key: interactionId,
      interaction: interaction,
      displayComponentPropsMap: {
        button: {
          size: null,
          compact: false
        }
      },
      event: {
        category: EVENT_CATEGORIES.HERO_EVENT_CATEGORY,
        action: EVENT_ACTIONS.HERO_INTERACTION_ACTION,
        label: _get(interaction, 'label', ''),
        value: _get(interaction, 'url', '')
      }
    });
  }))), !_isEmpty(files) && /*#__PURE__*/React.createElement("div", {
    className: "images-container"
  }, /*#__PURE__*/React.createElement(BasicCarousel, _extends({
    size: 1,
    displayIndicators: false,
    displayPlayPauseButton: true,
    autoScroll: true,
    slide: true,
    items: files.map(function (image) {
      var key = getItemKey(image, '_id');
      return /*#__PURE__*/React.createElement(Image, {
        key: key,
        src: getImageSource(image),
        altText: getImageAltText(image),
        background: true,
        loadStrategy: EAGER_LOAD_STRATEGY
      });
    })
  }, carouselProps || {}))));
}
TranquilTouch.defaultProps = defaultProps;